export var productArticlesInfo = {
    items: [
        {
            product: "Facility management",
            date: "18 June 2021",
            header: "Cost-Efficient Building Services with Data Insights",
            shortText: "Data-driven powered building maintenance programs are bringing new value to building services by driving proven outcomes...",
            url: "https://www.buildings.com/home/webinar/10196053/best-practices-to-reduce-costs-and-increase-efficiency-with-data-driven-building-services"
        },
        {
            product: "Facility management",
            date: "04 Mar 2025",
            header: "Top 11 Facilities Management Trends in 2025 and Beyond",
            shortText: "Discover the key facilities management trends reshaping technology adoption and business strategy in 2025 and beyond...",
            url: "https://www.fieldcircle.com/blog/facilities-management-trends"
        },
        {
            product: "Facility management",
            date: "07 Apr 2024",
            header: "Building Code Compliance Checklist - Attorney Aaron Hall",
            shortText: "A building code compliance checklist ensures all construction aspects meet legal and safety standards...",
            url: "https://aaronhall.com/building-code-compliance-checklist"
        },
        {
            product: "Facility management",
            date: "04 Dec 2024",
            header: "Complete Guide to Building Safety",
            shortText: "A comprehensive commercial property inspection checklist is vital for property management agencies looking to maintain safe, compliant, and valuable assets...",
            url: "https://www.pmva.com.au/commercial-property-inspection-checklist/"
        },
        {
            product: "Facility management",
            date: "26 Apr 2021",
            header: "Everything you need for a complete building review - ICC",
            shortText: "As the leading association for building safety, the International Code Council works with governmental jurisdictions, builders, architects, and engineers...",
            url: "https://www.iccsafe.org/building-safety-journal/bsj-hits/everything-you-need-for-a-complete-building-review/"
        },
        {
            product: "Facility management",
            date: "28 Jul 2023",
            header: "Commercial Building Compliance Checklist",
            shortText: "Business owners and the owners of commercial buildings have a legal duty to keep their building compliant...",
            url: "https://www.robinsonsfs.com/news/building-compliance-checklist/"
        },
        {
            product: "Facility management",
            date: "12 Jul 2022",
            header: "Urban Heat Island Mitigation",
            shortText: "The urban heat island (UHI) effect occurs when urban areas are hotter than surrounding areas...",
            url: "https://coolroofs.org/resources/urban-heat-island-mitigation?_gl=1*18v1h2g*_ga*MTkwOTQ3MjUyNS4xNzQ2MzAwMzA4*_ga_Z8JYBHH379*MTc0NjMwMDMwOC4xLjEuMTc0NjMwMDQ1My4wLjAuMA.."
        },
        {
            product: "Facility management",
            date: "31 Dec 2023",
            header: "Inspection Service Tiers",
            shortText: "Owners of multiple housing buildings are responsible for maintaining their buildings in compliance with minimum housing standards...",
            url: "https://www.sanjoseca.gov/your-government/departments-offices/planning-building-code-enforcement/code-enforcement/multiple-housing-inspection-program/inspection-service-tiers"
        },
        {
            product: "Facility management",
            date: "09 Dec 2020",
            header: "World Bank Document",
            shortText: "BUILDING CODE CHECKLIST FOR STRUCTURAL RESILIENCE...",
            url: "https://documents1.worldbank.org/curated/en/099062524011095572/pdf/P1760681f57d370781a11d18dc3013db0a1.pdf"
        },
        {
            product: "Roof Management",
            date: "26 Aug 2023",
            header: "Roof Assessment Articles",
            shortText: "This article we will review guidelines for  preparing roofing assessment reports...",
            url: "https://roofassessment.net/f/preparing-roofing-assessment-reports"
        },
        {
            product: "Roof Management",
            date: "14 Oct 2023",
            header: "Glossary of Terms for Roof Assessment",
            shortText: "The principal purpose of the following glossary is to serve as a useful and usable reference for those in the roofing industry...",
            url: "https://www.spri.org/download/resources_and_education_2/miscellaneous/Glossary_of_terms.pdf"
        },
        {
            product: "Roof Management",
            date: "12 Apr 2021",
            header: "How to Find the Best Options for Your Commercial Roofing Project",
            shortText: "A Complete Guide to Commercial Flat Roofing Systems & Materials...",
            url: "https://www.iko.com/comm/complete-guide-commercial-flat-roofing-systems-materials/"
        },
        {
            product: "Roof Management",
            date: "09 Jun 2020",
            header: "Standard Attributes - EPDM Roofing Association",
            shortText: "White EPDM combines the high-performance standards of traditional EPDM with a highly reflective, environmentally friendly...",
            url: "https://epdmroofs.org/what-is-epdm/why-epdm/standard-attributes/"
        },
        {
            product: "Roof Management",
            date: "07 Jun 2021",
            header: "BUR Multi-Ply Built-Up Roofing",
            shortText: "ARMA defines a built-up roofing system as a roof where multiple layers of asphalt alternated with ply sheets (felts) are applied over the roof deck...",
            url: "https://www.asphaltroofing.org/wp-content/uploads/2024/04/April_2024-BUR-Multi-Ply-Built-Up-Roofing-Revised.pdf"
        },
        {
            product: "Roof Management",
            date: "22 Jan 2023",
            header: "Effects of Urban Surfaces",
            shortText: "Land use, vegetation, albedo, and soil-type data are combined in a global model that accounts for roofs and roads...",
            url: "https://epdmroofs.org/resource/effects-of-urban-surfaces-and-white-roofs-on-global-and-regional-climate/"
        },
        {
            product: "Roof Management",
            date: "26 Aug 2023",
            header: "Introduction to Roof Asset Management",
            shortText: "This  article we will provide an overview of Roof  Asset Management (RAM) to provide  building owners, property managers...",
            url: "https://roofassessment.net/f/introduction-to-roof-asset-management"
        },
        {
            product: "Roof Management",
            date: "13 Sep 2022",
            header: "Inspecting Built-up Roofs",
            shortText: "Starting from the roof deck, a built-up roof membrane system may include the following components...",
            url: "https://hinarratives.com/reference/roof/inspecting-built-up-roofs/"
        },
        {
            product: "Roof Management",
            date: "17 Jun 2023",
            header: "What is a Cool Roof?",
            shortText: "A cool roof is one that strongly reflects sunlight (solar energy) and also cools itself by efficiently emitting any heat that was absorbed...",
            url: "https://coolroofs.org/resources/what-is-a-cool-roof?_gl=1*elllv6*_ga*MTkwOTQ3MjUyNS4xNzQ2MzAwMzA4*_ga_Z8JYBHH379*MTc0NjMwMDMwOC4xLjAuMTc0NjMwMDMwOC4wLjAuMA.."
        },
        {
            product: "Roof Management",
            date: "9 Jan 2008",
            header: "ASTM, RCI, and Quality Assurance",
            shortText: "Energy conservation and efficient building design are at the forefront...",
            url: "https://www.buildings.com/home/article/10192975/astm-rci-and-quality-assurance"
        },
        {
            product: "Roof Management",
            date: "01 Aug 2009",
            header: "Thermal Performance of Vegetated Roof Systems",
            shortText: "Vegetated, otherwise known as green or garden roofing, has seen tremendous growth in the last decade in the United States...",
            url: "https://www.spri.org/download/resources_and_education_2/energy_use/thermal_performance_of_vegetated_roof_systems_spri_2010.pdf"
        },
        {
            product: "Roof Management",
            date: "01 May 2025",
            header: "Debunking 5 Myths About Solar + Storage",
            shortText: "As Congress gears up to consider a tax package that will address credits for solar and storage, there are no shortage...",
            url: "https://seia.org/blog/debunking-myths/"
        },
        {
            product: "Roof Management",
            date: "22 Dec 2020",
            header: "How to Optimize Roof Performance with Timely Repairs",
            shortText: "Fall weather got a little strange in some parts of the country, and with everything else that’s been going on, the roof preventive maintenance might have slipped down the schedule....",
            url: "https://epdmroofs.org/resource/how-to-optimize-roof-performance-with-timely-repairs/"
        },
        {
            product: "Roof Management",
            date: "10 Feb 2025",
            header: "The performance of low-slope roofs during Hurricane Ian (2022)",
            shortText: "Low-slope roofs continue to present challenges in windstorms. Despite the development of new standards for materials and installation and continual code improvements....",
            url: "https://epdmroofs.org/resource/how-to-optimize-roof-performance-with-timely-repairs/"
        },
        {
            product: "Façade Assessment",
            date: "01 Mar 2025",
            header: "Facade Ordinance",
            shortText: "FacadeOrdinance.com contains general information regarding facade ordinances in various cities throughout the United States. It's intended for use by anyone seeking an introduction to facade ordinances...",
            url: "https://www.facadeordinance.com/"
        },
        {
            product: "Façade Assessment",
            date: "01 Mar 2025",
            header: "Boston | FacadeOrdinance.com",
            shortText: "The Inspectional Services Department administers the facade ordinance for the City of Boston. The department is located at 1010 Massachusetts Avenue...",
            url: "https://www.facadeordinance.com/boston"
        },
        {
            product: "Façade Assessment",
            date: "03 Sep 2024",
            header: "The Ultimate Guide to Understanding Local Law 11",
            shortText: "Local Law 11 is a critical regulation that building owners in some cities need to know about, especially if their buildings are over six stories tall...",
            url: "https://nycbuildingsinfo.com/post/the-ultimate-guide-to-understanding-local-law-11"
        },
        {
            product: "Façade Assessment",
            date: "04 Sep 2024",
            header: "Top Mistakes to Avoid in Complying with Local Law 11",
            shortText: "Local Law 11 is a vital regulation for building owners in New York City. This law helps ensure that the facades of buildings taller than six stories are safe and do not pose any risks...",
            url: "https://nycbuildingsinfo.com/post/top-mistakes-to-avoid-in-complying-with-local-law-11"
        },
        {
            product: "Façade Assessment",
            date: "14 Oct 2024",
            header: "Façade & Local Law",
            shortText: "To keep buildings safe, owners of properties higher than six stories must have exterior walls and appurtenances inspected every five (5) years...",
            url: "https://www.nyc.gov/site/buildings/safety/facade-local-law.page"
        },
        {
            product: "Façade Assessment",
            date: "18 Dec 2024",
            header: "Understanding Local Law 11",
            shortText: "Most board members and managers in New York City’s co-op and condo buildings know the drill when it comes to Local Law 11 inspections...",
            url: "https://cooperatornews.com/article/understanding-local-law-3"
        },
        {
            product: "Façade Assessment",
            date: "03 Mar 2018",
            header: "Masonry Inspection Checklist",
            shortText: "The Construction Practices Committee of The Masonry Society has prepared this checklist for use during the preconstruction...",
            url: "https://masonrysociety.org/wp-content/uploads/woocommerce_uploads/2018/03/Masory-Inspection-Checklist-2018.pdf"
        },
        {
            product: "Façade Assessment",
            date: "07 Mar 2025",
            header: "Facades & Florida Building Recertifications: Key Insights for Owner",
            shortText: "How Facades Impact Florida’s Building Recertification Process: Safety, Compliance, and Repairs...",
            url: "https://yourbuildingrecertification.com/how-facades-impact-floridas-building-recertification-process-safety-compliance-and-repairs/"
        },
        {
            product: "Façade Assessment",
            date: "30 Apr 2025",
            header: "Redefining Building Facades for Tomorrow Designs",
            shortText: "In the ever-evolving world of architecture and construction, building facades have long defined spaces, from ancient Roman architecture to today’s technology-powered buildings...",
            url: "https://www.metalconstructionnews.com/articles/redefining-building-facades/"
        },
        {
            product: "Façade Assessment",
            date: "22 Feb 2025",
            header: "Structural Glazing Façade Inspection Guidelines R1-0",
            shortText: "Structural Sealant Glazing (SSG) is popular because of its unique method of retaining glass or other panels in smooth exterior walls...",
            url: "https://www.miamidade.gov/building/library/structural-glazing-facade-inspection-guidelines.pdf"
        },
        {
            product: "Façade Assessment",
            date: "12 Mar 2025",
            header: "ASTM standards for facade inspection",
            shortText: "ASTM International, formerly known as the American Society for Testing and Materials, is a nonprofit organization that develops and publishes technical standards for materials...",
            url: "https://globaltecharch.in/astm-standards-for-facade-inspection/"
        },
        {
            product: "Façade Assessment",
            date: "18 Apr 2025",
            header: "12 Types of Curtain Wall System: A Comprehensive Guide",
            shortText: "Curtain walls are an important element of modern building design. They are used to create a façade on a building that is designed to resist wind and rain...",
            url: "https://glassforum.org/12-types-of-curtain-wall-system/"
        },
        {
            product: "Façade Assessment",
            date: "03 Sep 2025",
            header: "Your Guide to Chicago's Mandated Building Inspections 2020 | CAI-IL",
            shortText: "Don’t Forget About City of Chicago Mandated Building Inspections, They Are Not Only Limited to Facade Inspections...",
            url: "https://www.cai-illinois.org/chicagos-mandated-building-inspections/"
        },
        {
            product: "Façade Assessment",
            date: "08 Jul 2024",
            header: "Your ultimate guide to facade inspections",
            shortText: "The tools we use are constantly being phased out for better ones. What was once Blackberries and blueprints is now smartphones and BIM modeling...",
            url: "https://www.dronedeploy.com/blog/elevating-your-project-with-autonomous-facade-inspections"
        },
        {
            product: "Façade Assessment",
            date: "19 Jan 2024",
            header: "20 Different Curtain Wall Design Styles: The Art of Transparency",
            shortText: "The concept of curtain wall design encompasses an innovative approach to modern architecture. Since it is a non-structural facade, a curtain wall serves as an external covering...",
            url: "https://thearchitectsdiary.com/20-different-curtain-wall-design-styles-the-art-of-transparency/"
        },
        {
            product: "Façade Assessment",
            date: "17 Feb 2024",
            header: "The Building Envelope",
            shortText: "The building envelope comprises those systems that separate the interior from the outside world—protecting building occupants and contents from wind, moisture...",
            url: "https://www.superstructures.com/restoration-101/the-building-envelope/"
        },
        {
            product: "Façade Assessment",
            date: "22 Sep 2024",
            header: "Lessons Learned From Curtain Wall Failure Investigations",
            shortText: "Curtain walls are a form of exterior cladding that do not support floor or roof loads...",
            url: "https://iibec.org/publication-post/2011-03-mccowan-kivela/"
        },
        {
            product: "Façade Assessment",
            date: "14 Oct 2023",
            header: "Difference between a facade and a curtain wall",
            shortText: "In the ever-evolving world of architecture and construction, the language used to describe building components can be both nuanced and perplexing...",
            url: "https://alumshine.ca/facade-vs-curtain-wall/"
        },
        {
            product: "Façade Assessment",
            date: "25 Oct 2024",
            header: "Why Drone Facade Inspection is the Future of Building Maintenance",
            shortText: "The way we check building facades has changed indefinitely, as new methods have appeared that make it quicker and better...",
            url: "https://soldrones.com/blog/facade-inspection-drones-for-commercial-use/"
        },
        {
            product: "Façade Assessment",
            date: "23 Dec 2024",
            header: "Thermal breaks improve energy efficiency in rolling steel doors",
            shortText: "Thermal breaks significantly improve the energy efficiency of commercial building components, resulting in a lower, better U-factor rating...",
            url: "https://www.metalconstructionnews.com/articles/thermal-breaks-improve-energy-efficiency-in-rolling-steel-doors/"
        },
        {
            product: "Paving Management",
            date: "01 Mar 2025",
            header: "What are Cool Pavements?",
            shortText: "Roughly one-third of a typical city’s surface area is paved (Akbari and Rose). Many paved streets and parking lots use dark materials that absorb 80-95% of sunlight and warm our cities...",
            url: "https://coolroofs.org/resources/what-are-cool-pavements?_gl=1*1tvp5fq*_ga*MTkwOTQ3MjUyNS4xNzQ2MzAwMzA4*_ga_Z8JYBHH379*MTc0NjMwMDMwOC4xLjEuMTc0NjMwMDM2Ni4wLjAuMA.."
        },
        {
            product: "Paving Management",
            date: "08 Aug 2024",
            header: "Resurfacing Vs Replacing Your Parking Lot Asphalt",
            shortText: "Asphalt parking lots need to be maintained frequently to retain their appearance and functionality. The protective layer of asphalt will gradually degrade due to aging, exposure to sunlight...",
            url: "https://stateasphaltsealing.com/resurfacing-vs-replacing-your-parking-lot-asphalt/"
        },
        {
            product: "Paving Management",
            date: "12 Sep 2024",
            header: "Parking Lot Resurfacing Questions Answered",
            shortText: "Asphalt parking lots are a valuable asset to any property, but they require regular maintenance to keep them in tip top condition...",
            url: "https://www.hmacontracting.com/news/parking-lot-resurfacing-questions-answered/"
        },
        {
            product: "Paving Management",
            date: "12 Feb 2024",
            header: "Sealcoating vs. Resurfacing vs. Repaving: Which is right for you?",
            shortText: "Asphalt is cheap, durable, and when properly kept up looks extremely attractive as well. But besides simple pothole fixes or crack filling applications, there are...",
            url: "https://stripealot.org/sealcoating-vs-resurfacing-vs-repaving-which-is-right-for-you/"
        },
        {
            product: "VT Equipment Management",
            date: "01 Apr 2024",
            header: "How Often Do Elevators Need To Be Inspected?",
            shortText: "If you own a commercial building with an elevator, you must follow a regular elevator maintenance schedule to keep it in safe, working order for all occupants...",
            url: "https://elevatemonitoring.com/news-and-events/blog/how-often-do-elevators-need-to-be-inspected/"
        },
        {
            product: "VT Equipment Management",
            date: "12 Mar 2024",
            header: "Elevator - Buildings  NYC",
            shortText: "In accordance with the NYC Building Codes, elevators must be inspected and tested twice annually...",
            url: "https://www.nyc.gov/site/buildings/property-or-business-owner/elevator.page"
        },
        {
            product: "VT Equipment Management",
            date: "19 Dec 1996",
            header: "Occupational Safety and Health Administration",
            shortText: "\"Elevator\" means a permanent hoisting and lowering mechanism with a car or platform moving vertically in guides and serving two or more floors of a structure...",
            url: "https://www.osha.gov/laws-regs/regulations/standardnumber/1917/1917.116"
        },
        {
            product: "VT Equipment Management",
            date: "27 Jun 2024",
            header: "ASME A17.2-2023: Guide for Inspection of Elevators",
            shortText: "You could take the stairs for some exercise, but it’s hard to beat the convenience of a well-placed elevator (lift)....",
            url: "https://blog.ansi.org/ansi/asme-a17-2-2023-guide-inspection-elevators/"
        },
        {
            product: "VT Equipment Management",
            date: "01 Oct 2024",
            header: "Maintenance, Inspection, and Testing of Electric and Hydraulic Elevators",
            shortText: "Maintenance, Inspection, and Testing of Electric and Hydraulic Elevators....",
            url: "https://www.usbr.gov/power/data/fist/fist2_10/fist2-10.pdf"
        },
        {
            product: "VT Equipment Management",
            date: "25 Sep 2024",
            header: "Elevator Inspection 101: What Goes Behind Ensuring Safety",
            shortText: "If the elevators in your building are breaking down too often, you may need regular inspections. Elevator inspections help to keep these crucial machines running smoothly and safely...",
            url: "https://actionelevator.com/blog/elevator-inspection-101-what-goes-behind-ensuring-safety/"
        },
        {
            product: "VT Equipment Management",
            date: "21 Mar 2022",
            header: "Elevator Inspection Checklist and Scheduling",
            shortText: "Elevator contractors may schedule elevator inspections up to two weeks in advance. Scheduling inspections in advance can benefit both contractors and The Department of Labor...",
            url: "https://www.dli.mn.gov/sites/default/files/pdf/ele-checklist.pdf"
        },
        {
            product: "VT Equipment Management",
            date: "06 Jun 2011",
            header: "Conveyance Inspection Guidance",
            shortText: "This guidance document outlines, but does not replace, the requirements of inspection standards listed in the Colorado Conveyance Regulations...",
            url: "https://ops.colorado.gov/sites/ops/files/2020-02/conveyanceinspectionguidance.pdf"
        },
        {
            product: "VT Equipment Management",
            date: "11 Mar 2021",
            header: "Elevator Safety – Licensing",
            shortText: "Under Chapter 399, Florida Statutes, known as the Florida Elevator Safety Act, the owner/operator is responsible for ensuring the elevator meets all safety...",
            url: "https://www2.myfloridalicense.com/elevator-safety/licensing/"
        },
        {
            product: "VT Equipment Management",
            date: "24 Oct 2021",
            header: "Elevator Inspections",
            shortText: "The Department of Buildings (DOB) conducts inspections of all elevators in the District and Certificates of Inspection are issued by the Department of Licensing and Consumer Protection...",
            url: "https://dob.dc.gov/node/1616596"
        },
        {
            product: "VT Equipment Management",
            date: "10 Feb 2025",
            header: "§ 36-105.01. Elevator inspections by contract.",
            shortText: "The inspection of elevators in existing buildings and the enforcement of the Building Code for elevators shall be in compliance with the regulations adopted by the Board...",
            url: "https://law.lis.virginia.gov/vacode/title36/chapter6/section36-105.01/"
        }
    ]
}